import RequestBuilder from '../Lib/Requests';
export default class MaintenanceLogsService {
  api = new RequestBuilder();

  buildGetMaintenanceLogsRequest(params, cancelToken) {
    return {
      cancelToken,
      endpoint: '/v2/maintenance-log',
      method: 'get',
      params,
      service: 'maintenance',
    };
  }
  async getMaintenanceLogs(params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildGetMaintenanceLogsRequest(params, cancelToken)
    );
    return data;
  }

  buildDownloadMaintenanceLogsCsvRequest(params, cancelToken) {
    return {
      cancelToken,
      endpoint: '/v2/maintenance-log/csv',
      method: 'get',
      params,
      service: 'maintenance',
    };
  }
  async downloadMaintenanceLogsCsv(params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildDownloadMaintenanceLogsCsvRequest(params, cancelToken)
    );
    return data;
  }

  buildCreateMaintenanceLogsRequest(data, cancelToken) {
    return {
      cancelToken,
      data,
      endpoint: '/v2/maintenance-log',
      method: 'post',
      service: 'maintenance',
    };
  }
  async createMaintenanceLogs(body, cancelToken) {
    return this.api.request(
      this.buildCreateMaintenanceLogsRequest(body, cancelToken)
    );
  }
}
